<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รายงานเรียกเก็บตราประทับ</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        เลือกลูกค้าจากกลุ่ม billable ตามลาน แล้วค้นหารายการเพื่อเตรียมออกใบแจ้งหนี้
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="!canSearch || totalItems() <= 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!canSearch || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-sky-600 dark:text-sky-400 font-bold rounded-2xl shadow-sm border border-sky-100 dark:border-sky-900 hover:bg-sky-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'พิมพ์ PDF' }}
      </button>
      <button *ngIf="canUpdate" type="button" (click)="openConfirmMarkInvoiced()"
        [disabled]="!canSearch || pendingMatchCount() <= 0 || isLoading()"
        class="px-5 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">task_alt</span>
        ยืนยันออกใบแจ้งหนี้
        <span *ngIf="pendingMatchCount() > 0"
          class="ml-1 px-2 py-0.5 rounded-lg bg-white/70 text-xs font-black">{{ pendingMatchCount() }}</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden print-area">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4 no-print">
      <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 flex-wrap">
          <span class="material-icons text-amber-500">receipt_long</span>
          รายการเรียกเก็บ
          <span *ngIf="siteState.selectedSite()?.name"
            class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
            {{ siteState.selectedSite()?.name }}
          </span>
        </h3>
        <div class="relative w-full lg:max-w-md">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [ngModel]="searchText" (ngModelChange)="onSearchInput($event)"
            [disabled]="!canSearch"
            placeholder="ค้นหาทะเบียน / กลุ่ม / หมายเหตุ..."
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none disabled:opacity-50" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <div>
          <app-pss-searchable-picker
            label="ลูกค้า"
            icon="storefront"
            placeholder="ค้นหาชื่อลูกค้า..."
            [required]="true"
            [selectedId]="cpCustomerId"
            [displayText]="cpCustomerLabel"
            [options]="customerPickerOptions()"
            [total]="customerPickerTotal()"
            [previewSize]="20"
            [loading]="customerPickerLoading()"
            (opened)="onCustomerOpened()"
            (searchChange)="onCustomerSearch($event)"
            (optionSelected)="onCustomerSelected($event)"
            (cleared)="onCustomerCleared()">
          </app-pss-searchable-picker>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากวันที่</label>
          <div
            class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
            <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
              <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
              <span class="material-icons text-slate-400 text-lg">calendar_today</span>
            </div>
            <input #startDatePicker type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
              [max]="endDate || undefined" (click)="startDatePicker.showPicker()"
              class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ถึงวันที่</label>
          <div
            class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
            <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
              <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
              <span class="material-icons text-slate-400 text-lg">calendar_today</span>
            </div>
            <input #endDatePicker type="date" [(ngModel)]="endDate" (ngModelChange)="onFilterChange()"
              [min]="startDate || undefined" (click)="endDatePicker.showPicker()"
              class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
          <select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()" [disabled]="!canSearch"
            class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50">
            <option value="">ทั้งหมด</option>
            <option value="pending">รอดำเนินการ</option>
            <option value="invoiced">ออกใบแจ้งหนี้แล้ว</option>
            <option value="cancelled">ยกเลิก</option>
          </select>
        </div>
      </div>

      <div *ngIf="canSearch"
        class="flex flex-wrap items-center gap-3 text-xs font-semibold text-slate-500 dark:text-slate-400">
        <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700">
          <span class="material-icons text-[14px] text-amber-500">schedule</span>
          เวลาจอดรวมหน้านี้: {{ pageDurationText }}
        </span>
        <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 border border-amber-100 dark:border-amber-800">
          รอดำเนินการตามช่วงวันที่: {{ pendingMatchCount() | number }} รายการ
        </span>
      </div>
    </div>

    <!-- สรุปยอดทั้งชุดตาม filter (ไม่รวม cancelled) -->
    <div *ngIf="canSearch" class="px-6 py-4 border-b border-slate-100/70 dark:border-slate-700">
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/60 border border-slate-100 dark:border-slate-700 p-4">
          <div class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">จำนวนรายการ</div>
          <div class="mt-1 text-xl font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ totalItems() | number }}</div>
        </div>
        <div class="rounded-2xl bg-sky-50/80 dark:bg-sky-950/30 border border-sky-100 dark:border-sky-900 p-4">
          <div class="text-[11px] font-bold text-sky-500 uppercase tracking-wider">รวมค่าธรรมเนียม</div>
          <div class="mt-1 text-xl font-black text-sky-700 dark:text-sky-300 tabular-nums">{{ sumFee() | number:'1.2-2' }}</div>
          <div class="mt-1 text-[10px] text-slate-400 font-medium">ไม่รวมรายการยกเลิก</div>
        </div>
        <div class="rounded-2xl bg-violet-50/80 dark:bg-violet-950/30 border border-violet-100 dark:border-violet-900 p-4">
          <div class="text-[11px] font-bold text-violet-500 uppercase tracking-wider">รวมภาษีมูลค่าเพิ่ม</div>
          <div class="mt-1 text-xl font-black text-violet-700 dark:text-violet-300 tabular-nums">{{ sumVat() | number:'1.2-2' }}</div>
          <div class="mt-1 text-[10px] text-slate-400 font-medium">ไม่รวมรายการยกเลิก</div>
        </div>
        <div class="rounded-2xl bg-amber-50/80 dark:bg-amber-950/30 border border-amber-100 dark:border-amber-900 p-4">
          <div class="text-[11px] font-bold text-amber-600 uppercase tracking-wider">ยอดรวมทั้งสิ้น</div>
          <div class="mt-1 text-xl font-black text-amber-700 dark:text-amber-300 tabular-nums">{{ sumTotal() | number:'1.2-2' }}</div>
          <div class="mt-1 text-[10px] text-slate-400 font-medium">ไม่รวมรายการยกเลิก</div>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse min-w-[1200px]" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap">
            <th class="p-4">วันที่เรียกเก็บ</th>
            <th class="p-4">ทะเบียน</th>
            <th class="p-4">กลุ่ม / เรท</th>
            <th class="p-4">เวลาเข้า</th>
            <th class="p-4">เวลาออก</th>
            <th class="p-4">เวลาจอดรวม</th>
            <th class="p-4 text-right">ค่าธรรมเนียม</th>
            <th class="p-4 text-right">ภาษีมูลค่าเพิ่ม</th>
            <th class="p-4 text-right">รวม</th>
            <th class="p-4 text-center">สถานะ</th>
            <th *ngIf="canCreate" class="p-4 text-center no-print">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all align-top">
            <td class="p-4 text-xs tabular-nums text-slate-600 dark:text-slate-300 whitespace-nowrap">
              {{ item.chargeDate ? (item.chargeDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ item.entryLicense || '—' }}</div>
              <div class="text-[11px] text-slate-400">ธุรกรรม {{ item.parkingTransactionId }}</div>
            </td>
            <td class="p-4 min-w-[160px]">
              <div class="font-medium text-slate-700 dark:text-slate-200">{{ item.groupName || '—' }}</div>
              <div class="text-[11px] text-slate-400 truncate max-w-[220px]" [title]="(item.rateId || '') + ' ' + (item.rateName || '')">
                {{ item.rateId || '' }} {{ item.rateName || '' }}
              </div>
            </td>
            <td class="p-4 text-xs tabular-nums whitespace-nowrap">
              {{ item.entryDate ? (item.entryDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            </td>
            <td class="p-4 text-xs tabular-nums whitespace-nowrap">
              <span *ngIf="item.exitDate">{{ item.exitDate | date:'dd/MM/yyyy HH:mm' }}</span>
              <span *ngIf="!item.exitDate" class="text-amber-600 dark:text-amber-400 font-semibold">ยังอยู่ในลาน</span>
            </td>
            <td class="p-4 text-xs font-semibold text-slate-700 dark:text-slate-200 whitespace-nowrap">
              {{ durationText(item.parkingDurationMinutes) }}
            </td>
            <td class="p-4 text-right tabular-nums font-semibold"
              [class.line-through]="item.status === 'cancelled'"
              [class.text-slate-400]="item.status === 'cancelled'">{{ item.fee | number:'1.2-2' }}</td>
            <td class="p-4 text-right tabular-nums"
              [class.line-through]="item.status === 'cancelled'"
              [class.text-slate-400]="item.status === 'cancelled'">{{ item.vat | number:'1.2-2' }}</td>
            <td class="p-4 text-right tabular-nums font-black text-slate-800 dark:text-slate-100"
              [class.line-through]="item.status === 'cancelled'"
              [class.text-slate-400]="item.status === 'cancelled'">{{ item.total | number:'1.2-2' }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="statusClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td *ngIf="canCreate" class="p-4 text-center no-print">
              <button type="button" (click)="openEditRow(item)" title="แก้ไข"
                class="w-9 h-9 inline-flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-amber-600 hover:border-amber-300 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all cursor-pointer bg-transparent">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td [attr.colspan]="canCreate ? 11 : 10" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block opacity-40">apartment</span>
              <p class="font-bold">กรุณาเลือกลานจากแถบด้านบน</p>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !cpCustomerId && !isLoading()">
            <td [attr.colspan]="canCreate ? 11 : 10" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block opacity-40">person_search</span>
              <p class="font-bold">กรุณาเลือกลูกค้าเพื่อค้นหารายงาน</p>
            </td>
          </tr>
          <tr *ngIf="canSearch && !isLoading() && items().length === 0">
            <td [attr.colspan]="canCreate ? 11 : 10" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block opacity-40">search_off</span>
              <p class="font-bold">ไม่พบข้อมูลตามเงื่อนไข</p>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="canSearch && items().length > 0">
          <tr class="bg-slate-50/80 dark:bg-slate-900/40 border-t border-slate-200 dark:border-slate-700 font-bold">
            <td class="p-4 text-slate-600 dark:text-slate-300" colspan="6">
              ยอดรวมทั้งชุด (ไม่รวมยกเลิก) — แสดง {{ totalItems() | number }} รายการ
            </td>
            <td class="p-4 text-right tabular-nums text-sky-700 dark:text-sky-300">{{ sumFee() | number:'1.2-2' }}</td>
            <td class="p-4 text-right tabular-nums text-violet-700 dark:text-violet-300">{{ sumVat() | number:'1.2-2' }}</td>
            <td class="p-4 text-right tabular-nums text-amber-700 dark:text-amber-300">{{ sumTotal() | number:'1.2-2' }}</td>
            <td class="p-4" [attr.colspan]="canCreate ? 2 : 1"></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4 no-print">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()" [disabled]="!canSearch"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1 || !canSearch"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 bg-transparent'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0 || !canSearch"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Confirm mark invoiced -->
<div *ngIf="showConfirmModal()" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4"
  (click)="closeConfirmModal()">
  <div class="bg-white dark:bg-slate-900 w-full max-w-md rounded-[1.75rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100">ยืนยันเปลี่ยนสถานะ</h3>
      <p class="text-xs text-slate-400 mt-1">รอดำเนินการ → ออกใบแจ้งหนี้แล้ว</p>
    </div>
    <div class="p-6 space-y-3 text-sm text-slate-600 dark:text-slate-300">
      <div class="rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 p-4 space-y-2">
        <div class="flex justify-between gap-3"><span class="text-slate-400">ลูกค้า</span><span class="font-bold text-right">{{ cpCustomerLabel || '—' }}</span></div>
        <div class="flex justify-between gap-3"><span class="text-slate-400">ลาน</span><span class="font-bold text-right">{{ siteState.selectedSite()?.name || '—' }}</span></div>
        <div class="flex justify-between gap-3"><span class="text-slate-400">ช่วงวันที่</span>
          <span class="font-bold tabular-nums">{{ startDate | date:'dd/MM/yyyy' }} – {{ endDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="flex justify-between gap-3 pt-2 border-t border-slate-200/70 dark:border-slate-700">
          <span class="text-slate-400">จำนวนรายการที่จะเปลี่ยน</span>
          <span class="font-black text-amber-600 text-lg">{{ pendingMatchCount() | number }}</span>
        </div>
      </div>
      <p class="text-xs text-slate-400 leading-relaxed">
        ระบบจะเปลี่ยนเฉพาะรายการสถานะรอดำเนินการในช่วงวันที่และลูกค้าที่เลือก (ไม่สร้างใบแจ้งหนี้จริงในขั้นตอนนี้)
      </p>
    </div>
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex gap-3">
      <button type="button" (click)="closeConfirmModal()" [disabled]="isMarking()"
        class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 cursor-pointer bg-transparent disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="confirmMarkInvoiced()" [disabled]="isMarking()"
        class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">
        {{ isMarking() ? 'กำลังบันทึก...' : 'ตกลง' }}
      </button>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'รายงานเรียกเก็บตราประทับ (PDF Preview)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-modal-stamp-billable-charge-edit
  *ngIf="showEditModal() && editingRow()"
  [row]="editingRow()!"
  (close)="closeEditModal()"
  (saveSuccess)="onEditSaved()">
</app-modal-stamp-billable-charge-edit>

<app-pss-loading *ngIf="isProcessingPdf()" text="กำลังโหลดไฟล์ PDF" detail="โปรดรอสักครู่ . . ."></app-pss-loading>
